<script lang="ts">
import SectionEtablissementCaisses from '@/generated/sections/SectionEtablissementCaisses.vue';
import User from '@/extend/classes/User';
import Owner from '@/extend/classes/Owner';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Support from '@/extend/classes/Support';
import { SupportNotif } from '@/generated/classes/Support';
import Button from '@/framework/base/classes/Button';
import { defineComponent } from "vue";
import Notif from '@/generated/classes/Notif';
import ListData, { ColumnFilter, ListChoix, ListFilter } from '@/extend/classes/ListData';

export default defineComponent({
  extends: SectionEtablissementCaisses,
  name: 'SectionEtablissementCaissesExtend',
  components: {},
  data() {
    return {
      hasCaisseComplementaireNotif: false,
    };
  },
  watch: {
    'editEtablissement.id': {
      immediate: true,
      handler: 'loadCaisseComplementaireNotif',
    },
  },
  computed: {
    fields(): string[] {
      return ['URSSAF', 'FNAS', 'CONGES_SPEC', 'RETRAITE_COMPLEMENTAIRE_ID'];
    },
    supportActions(): string[] {
      return ['VALIDATE'];
    },
    extraButtons(): Button[] {
      const buttons: Button[] = [];
      if (User.isSupport()) {
        if (this.hasCaisseComplementaireNotif) {
          const caisseComplementaireButton = new Button();
          caisseComplementaireButton.label = "Notification traitée";
          caisseComplementaireButton.show = true;
          caisseComplementaireButton.disabled = false;
          caisseComplementaireButton.outlined = true;
          caisseComplementaireButton.callback = this.caisseComplementaireAction;
          buttons.push(caisseComplementaireButton);

          const caisseComplementaireHelp = new Button();
          caisseComplementaireHelp.label = "Aide";
          caisseComplementaireHelp.show = true;
          caisseComplementaireHelp.disabled = false;
          caisseComplementaireHelp.outlined = true;
          caisseComplementaireHelp.callback = this.caisseComplementaireHelp;
          buttons.push(caisseComplementaireHelp);

        }
      }
      return buttons;
    },
  },
  methods: {
    loadCaisseComplementaireNotif(): void {
      if (!User.isSupport() || this.editEtablissement.id <= 0) {
        this.hasCaisseComplementaireNotif = false;
        return;
      }

      const filter = new ListFilter();
      filter.page = 1;
      filter.pageLimit = 20;

      const ownerIdFilter = new ColumnFilter();
      ownerIdFilter.name = 'ownerId';
      ownerIdFilter.staticFilter = true;
      const ownerId = new ListChoix();
      ownerId.value = this.editEtablissement.id;
      ownerIdFilter.filters.push(ownerId);

      const ownerTypeFilter = new ColumnFilter();
      ownerTypeFilter.name = 'ownerType';
      ownerTypeFilter.staticFilter = true;
      const ownerType = new ListChoix();
      ownerType.value = ObjTypes.ETABLISSEMENT;
      ownerTypeFilter.filters.push(ownerType);

      filter.columnsFilter = [ownerIdFilter, ownerTypeFilter];
      Notif.list(filter)
        .then((data: ListData) => {
          this.hasCaisseComplementaireNotif = (data.reccords as Notif[])
            .some(notif => notif.code == 'CAISSE_COMPLEMENTAIRE');
        })
        .catch(() => {
          this.hasCaisseComplementaireNotif = false;
        });
    },
    isDisplayed(value: string): boolean {
      let res = true;
      if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
        this.displayMap.set("URSSAF", true);
        this.displayMap.set("FNAS", this.requiredMissing(requiredAttributs, "FNAS") || (this.editEtablissement.conventionCode == "1285" && !!this.fiche));
        this.displayMap.set("CONGES_SPEC", this.requiredMissing(requiredAttributs, "CONGES_SPEC") || !!this.fiche);
        this.displayMap.set("RETRAITE_COMPLEMENTAIRE_ID", false);
      }
      const display = this.displayMap.get(value);
      if (display != undefined) {
        res = display;
      }
      return res;
    },
    picto(): string {
      return 'SectionPictoImmatriculation'
    },
    caisseComplementaireAction(): Promise<void> {
      return new Promise((resolve) => {
        const supportNotif = new SupportNotif();
        supportNotif.code = 'CAISSE_COMPLEMENTAIRE';
        supportNotif.owner = new Owner();
        supportNotif.owner.objType = ObjTypes.ETABLISSEMENT;
        supportNotif.owner.objId = this.editEtablissement.id;
        supportNotif.action = 'VALIDER';
        Support.manageNotif(supportNotif).then(() => {
          this.hasCaisseComplementaireNotif = false;
          resolve();
        });
      });
    },
    caisseComplementaireHelp(): Promise<void> {
      return new Promise((resolve) => {
        const supportNotif = new SupportNotif();
        supportNotif.code = 'CAISSE_COMPLEMENTAIRE';
        Support.helpNotif(supportNotif).then(() => {
          resolve();
        });
      });
    },
    sectionSave(): void {
      return this.save()
    },
  },
});
</script>